import { Instance, types } from "mobx-state-tree";
import { withSetPropAction } from "@/models/helpers/withSetPropAction";
import { INTEGRATION_TYPE, PAY_ENUM, PAY_TYPE } from "@/apis/checkout/constants/constants";
import { IPaymentVo } from "@/apis/checkout/checkout.interface";

const IPayResultVo = types.model("PayResultVo ", {
  orderId: types.string,
  id: types.string,
});


/**
 * 支付相关状态
 * 
 */
export const PaymentStoreModel = types
  .model("PaymentStore")
  .props({
    paymentList: types.array(types.frozen({})),
    payResult: types.optional(IPayResultVo, {
      orderId: "",
      id: "",
    }), // 支付结果
    disabledPayMethods: types.array(types.frozen(String)), // 禁用的支付方式
    paymentConfigs: types.optional(types.frozen({}), {
      [PAY_TYPE.GOOGLE_PAY]: {
        merchantInfo: {},
      }
    }),
    // 是否显示klarna OSM
    isShowKlarnaOSM: types.optional(types.boolean, true),
  })
  .views((self) => ({
    get payMethod() {
      try {
        return Number(
          (self.paymentList.filter((pay: any) => (pay as any).selected)[0] as any).payToolId,
        );
      } catch (error) {
        return 0;
      }
    },
    // 提交订单按钮是否不可用
    get submitOrderBtnDisabled() {
      return self.paymentList.length === 0;
    },
    // 当前支付信息
    get currentPayInfo() {
      const res: IPaymentVo | {} = self.paymentList.filter((pay: any) => (pay as any).selected)?.[0] || {};
      return res;
    },

    // 当前快捷账号信息
    get currentPayAccount() {
      console.log('self----');
      return (self as any).currentPayInfo?.paymentAccountList?.filter((pay: any) => (pay as any).checked)?.[0]
        || {
        accountName: "",
        payAccountSeqNo: "",
      };
    },
    // 当前账号是否是快捷账号
    get isQuickPay() {
      return !!((self as any).currentPayAccount?.payAccountSeqNo);
    },

    // 当时是否是BNP信用卡表单支付
    get isBnpCreditCardForm() {
      return (
        (self as any).payMethod === PAY_TYPE.CREDIT_CARD &&
        ((self as any).currentPayInfo as any)?.payEnum === PAY_ENUM.BNP &&
        ((self as any).currentPayInfo as any)?.integrationType === INTEGRATION_TYPE.PAYMENT
      );
    },
  }))
  .actions(withSetPropAction)
  .actions((self: any) => ({
    setPaymentList(data: IPaymentVo[]) {
      self.paymentList = data;
      let configMap: any = {}
      data.forEach((payment: IPaymentVo) => {
        configMap[payment.payMethod] = {
          ...self.paymentConfigs[payment.payMethod],
          // google pay 初始值不能为空
          ...(payment.payMethod === PAY_TYPE.GOOGLE_PAY ? (payment?.initConfig || {}) : payment.initConfig)
        };
      })
      self.paymentConfigs = configMap
    },
    setPayResult(data: any) {
      self.payResult = data;
    },
    setIsShowKlarnaOSM: (data: boolean) => {
      self.isShowKlarnaOSM = data;
    }
  }));

export interface PaymentStoreModel extends Instance<typeof PaymentStoreModel> { }
